import RadioGroupPrimitive from './RadioGroup';
import { IRadioGroup as IRadioGroupPrimitive } from './RadioGroup.interfaces';

export default RadioGroupPrimitive;
export { RadioGroupPrimitive, IRadioGroupPrimitive };
